var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',[_vm._v(_vm._s(_vm.minutes)+" Minuten")])])
}
var staticRenderFns = []

export { render, staticRenderFns }